var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.74668 0.532227C7.5881 0.532227 8.24545 0.869301 8.71875 1.54345C9.19204 2.2176 9.42869 3.07936 9.42869 4.12875C9.43453 5.43253 9.04889 6.46601 8.27175 7.2292C8.17241 7.33095 8.13735 7.46133 8.16657 7.62033L8.36816 8.07824C8.43243 8.23088 8.52738 8.35013 8.65301 8.43599C8.77864 8.52184 9.04304 8.64427 9.44622 8.80327C9.46375 8.80963 9.83333 8.94001 10.555 9.1944C11.2766 9.4488 11.6608 9.58872 11.7075 9.61416C12.1983 9.83675 12.5197 10.0689 12.6716 10.3106C12.8352 10.7112 12.9171 11.7256 12.9171 13.3538H0.576314C0.576314 11.7256 0.658117 10.7112 0.821726 10.3106C0.973648 10.0689 1.29502 9.83675 1.78585 9.61416C1.83259 9.58872 2.21678 9.4488 2.93841 9.1944C3.66004 8.94001 4.02962 8.80963 4.04715 8.80327C4.45032 8.64427 4.71473 8.52184 4.84035 8.43599C4.96598 8.35013 5.06093 8.23088 5.12521 8.07824L5.3268 7.62033C5.35601 7.46133 5.32095 7.33095 5.22162 7.2292C4.44448 6.46601 4.05883 5.43253 4.06468 4.12875C4.06468 3.07936 4.30132 2.2176 4.77462 1.54345C5.24791 0.869301 5.90527 0.532227 6.74668 0.532227Z",
    fill: "#6184AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.5a7de9ff34bec6633336694f6f4a15fb.svg";
export { ForwardRef as ReactComponent };